export const FETCH_PURCHASE_ORDER_REQUEST = "FETCH_PURCHASE_ORDER_REQUEST";
export const FETCH_PURCHASE_ORDER_SUCCESS = "FETCH_PURCHASE_ORDER_SUCCESS";
export const FETCH_PURCHASE_ORDER_FAIL = "FETCH_PURCHASE_ORDER_FAIL";

export const ADD_PURCHASE_ORDER_REQUEST = "ADD_PURCHASE_ORDER_REQUEST";
export const ADD_PURCHASE_ORDER_SUCCESS = "ADD_PURCHASE_ORDER_SUCCESS";
export const ADD_PURCHASE_ORDER_FAIL = "ADD_PURCHASE_ORDER_FAIL";

export const UPDATE_SUPPLIER_REQUEST = "UPDATE_SUPPLIER_REQUEST";
export const UPDATE_SUPPLIER_SUCCESS = "UPDATE_SUPPLIER_SUCCESS";
export const UPDATE_SUPPLIER_FAIL = "UPDATE_SUPPLIER_FAIL";
